import VerifyBtn from '@/components/VerifyBtn/VerifyBtn';
import { mapGetters } from 'vuex';
import { accountManagementApi } from '@/api/user/accountManagementApi';
import { getErrorLabelMixin } from '@/common/mixin/getErrorLabel';
import { getterTypes } from '@/store/getter-types';
import TextFieldComponent from "@/components/Form/TextField";

export default {
  name: 'TradersPwd',
  mixins: [getErrorLabelMixin],
  data() {
    return {
      form: {
        emailCode: '',
        phoneCode: '',
        ga_code: '',
        payPassword: '',
        reqPayPassword: '',

        newPassword: '', // 修改交易密码时才需要使用
        oldPassword: '', // 修改交易密码时才需要使用
        reNewPassword: '',
        isModify: false, // 给校验器用，不用传递给后台
        isNeedPhoneCode: false, // 给校验器用，不用传递给后台
        isNeedEmailCode: false, // 给校验器用，不用传递给后台
      },
      isUpdate: false,
      committing: false,
      rules: {
        payPassword: {
          required: true,
          regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[\s\S]{6,20}$/
        },
        reqPayPassword: {
          required: true,
          regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[\s\S]{6,20}$/
        },
        oldPassword: {
          required: true,
          regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[\s\S]{6,20}$/
        },
        newPassword: {
          required: true,
          regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[\s\S]{6,20}$/
        },
        reNewPassword: {
          required: true,
          regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[\s\S]{6,20}$/
        },
        gaCode: {
          required: true,
          numeric: true,
          length: 6
        }
      }
    };
  },
  methods: {
    async submitBtnClick() {
      // this.$v.form.$touch();

      // if (this.$v.form.$error || this.committing) {
      //   return;
      // }

      let validated = await this.$refs.validate.validate();
      if (!validated || this.committing) {
        return;
      }

      this.committing = true;
      let data = {};

      if (this.Getter_User_Info.paymentPasswordStatus === 0) {
        // data.emailCode = this.form.emailCode;
        // data.phoneCode = this.form.phoneCode;
        data.password = this.form.payPassword;
        data.gaCode = this.form.gaCode;
        this._requestBindTradersPwd(data);
      } else {
        // data.emailCode = this.form.emailCode;
        // data.phoneCode = this.form.phoneCode;
        data.newPassword = this.form.newPassword;
        data.oldPassword = this.form.oldPassword;
        data.gaCode = this.form.gaCode;
        this._requestModifyTradersPwd(data);
      }
    },
    // 提交设置交易密码数据
    _requestBindTradersPwd(data) {
      accountManagementApi.setTxPassword(data)
        .then((res) => {
          this.committing = false;
          if (res.errcode === 0) {
            this.successNotify(this.$t('success.txnPwd.set'));
            this.$router.push('/usercenter/account-management');
          }
        })
        .catch(() => {
          this.committing = false;
        });
    },
    // 提交修改交易密码数据
    _requestModifyTradersPwd(data) {
      accountManagementApi.updateTxPassword(data)
        .then((res) => {
          this.committing = false;
          if (res.errcode === 0) {
            this.successNotify(this.$t('success.resetPwd'));
            this.$router.push('/usercenter/account-management');
          }
        })
        .catch(() => {
          this.committing = false;
        });
    },
  },
  computed: {
    ...mapGetters([getterTypes.Getter_User_Info]),
    errorMsgs() {
      return {
        phoneCode: {
          requiredIf: this.$t('v.common.mobile.required'),
          phoneCode: this.$t('v.common.mobile.format'),
        },
        emailCode: {
          requiredIf: this.$t('v.common.email.required'),
          emailCode: this.$t('v.common.email.format'),
        },
        gaCode: {
          required: this.$t('v.common.gaCode.required'),
          gaCode: this.$t('v.common.gaCode.format'),
        },
        payPassword: {
          requiredUnless: this.$t('v.common.txnPwd.required'),
          pwdValid: this.$t('v.common.txnPwd.format'),
        },
        reqPayPassword: {
          requiredUnless: this.$t('v.common.txnPwd.retype'),
          sameAs: this.$t('v.common.secondPwd.sameAs'),
        },
        oldPassword: {
          requiredIf: this.$t('v.common.txnPwd.required'),
          // pwdValid: null,
        },
        newPassword: {
          requiredIf: this.$t('v.common.txnPwd.required'),
          notSame: this.$t('v.common.txnPwd.notsame'),
          pwdValid: this.$t('v.common.txnPwd.format'),
        },
        reNewPassword: {
          requiredIf: this.$t('v.common.secondPwd.required'),
          sameAs: this.$t('v.common.secondPwd.sameAs'),
        },
      };
    },
  },
  components: {
    VerifyBtn,
    TextFieldComponent
  },
  watch: {
    Getter_User_Info(newval) {
      if (newval.paymentPasswordStatus === 1) {
        // this.isUpdate = true;
        this.form.isModify = true;
      }
      if (newval.enablePhoneCheck === 1) {
        this.form.isNeedPhoneCode = true;
      }
      if (newval.enableEmailCheck === 1) {
        this.form.isNeedEmailCode = true;
      }
    },
  },
  mounted() {
    let userInfo = this.Getter_User_Info;
    if (userInfo.id && userInfo.paymentPasswordStatus === 1) {
      this.form.isModify = true;
    }
    // let isUpdate = this.$route.params.isUpdate;
    // if (isUpdate && isUpdate === 1) {
    //   this.isUpdate = true;
    //   this.form.isModify = true;
    // } else {
    //   if (userInfo.id && userInfo.paymentPasswordStatus === 1) {
    //     this.isUpdate = true;
    //     this.form.isModify = true;
    //   }
    //   if (userInfo.enablePhoneCheck === 1) {
    //     this.form.isNeedPhoneCode = true;
    //   }
    //   if (userInfo.enableEmailCheck === 1) {
    //     this.form.isNeedEmailCode = true;
    //   }
    // }
  },
};
